import React from "react";
import { Link } from "react-router-dom";

// =====================================================
// CONTACT IMAGES
// =====================================================
import img01 from "../../images/contact/img01.png";
import img02 from "../../images/contact/img02.png";
import img03 from "../../images/contact/img03.png";
import img04 from "../../images/contact/Pune.png";
import img05 from "../../images/contact/Noida.png";
import img07 from "../../images/contact/Indore.png";
import img08 from "../../images/contact/USA.png";

// =====================================================
// ARROW ICONS
// =====================================================
import arrowWhite from "../../images/icon/rotate-arrow-white02.svg";
import arrowBlack from "../../images/icon/rotate-arrow-black03.svg";

// =====================================================
// CONTACT DATA
// =====================================================
const contactData = [
  {
    location: "Bengaluru",
    address:
      "5th Floor, Neil Rao Towers, 117 & 118, Rd Number 3, Vijayanagar, EPIP Phase I, Whitefield, Bengaluru, Karnataka 560066",
    phone: "+91-8088913516",
    email: "contactus@digicomm.org",
    img: img01,
  },

  {
    location: "Bengaluru",
    address:
      "No 207, 2nd Floor, Jayanivas, Paduka Mandira Road, Near Brigade 7 Gardens, Bengaluru, Karnataka 560061",
    phone: "+91-8088913516",
    email: "contactus@digicomm.org",
    img: img01,
  },

  {
    location: "USA",
    address:
      "Digicomm Semiconductor INC, Riverpark Tower, 333 W San Carlos St, San Jose, CA 95110",
    phone: "+1 408 8238333",
    email: "contactus@digicomm.org",
    img: img08,
  },

  {
    location: "Pune",
    address:
      "11th Floor, Amar Business Zone, Baner Balewadi Main Road, Swati Park, Veerbhadra Nagar, Baner, Pune, Maharashtra 411045",
    phone: "+91-8088913516",
    email: "contactus@digicomm.org",
    img: img04,
  },

  {
    location: "Noida",
    address:
      "AltF Noida 142 - Ground Floor, Plot No. 21 & 21A, Sector 142, Noida, Uttar Pradesh 201305",
    phone: "+91-8088913516",
    email: "contactus@digicomm.org",
    img: img05,
  },

  {
    location: "Indore",
    address:
      "2nd Floor, 201 Singapore Business Park, LIG Square, Indore, Madhya Pradesh 452001",
    phone: "+91-8088913516",
    email: "contactus@digicomm.org",
    img: img07,
  },
];

// =====================================================
// CONTACT INFO SECTION
// =====================================================
const ContactInfoSection: React.FC = () => {
  return (
    <>
      <section className="contact digicomm-contact-section pb-150">
        <div className="container">
          <div className="contact-offices-heading"><span className="sub-title">Our locations</span><h2>Connected teams. Global reach.</h2></div><div className="row mt-none-30 justify-content-center">

            {contactData.map((item, index) => (
              <div
                className="col-xl-3 col-lg-4 col-md-6 mt-30"
                key={`${item.location}-${index}`}
              >

                {/*
                =====================================================
                OLD CARD WITH IMAGE HOVER EFFECT
                =====================================================

                <div className="
                  xb-contact-items
                  digicomm-contact-card
                  img-hove-effect
                  xb-border
                ">

                "img-hove-effect" has been removed because
                we do not want image blur / hover animation.
                =====================================================
                */}

                <div className="xb-contact-items digicomm-contact-card xb-border">

                  <div className="xb-item--inner">

                    {/* =================================================
                        IMAGE
                        Only ONE image is required now.
                    ================================================= */}
                    <div className="xb-img">

                      <Link to="/contact">
                        <img
                          src={item.img}
                          alt={`${item.location} office`}
                        />
                      </Link>

                      {/*
                      =================================================
                      OLD DUPLICATE IMAGES USED FOR HOVER ANIMATION

                      COMMENTED OUT because hover effect is disabled.
                      =================================================

                      <Link to="/contact">
                        <img
                          src={item.img}
                          alt={`${item.location} office`}
                        />
                      </Link>

                      <Link to="/contact">
                        <img
                          src={item.img}
                          alt={`${item.location} office`}
                        />
                      </Link>

                      <Link to="/contact">
                        <img
                          src={item.img}
                          alt={`${item.location} office`}
                        />
                      </Link>

                      =================================================
                      */}

                    </div>

                    {/* =================================================
                        CONTENT
                    ================================================= */}
                    <div className="xb-item--holder">

                      {/* LOCATION */}
                      <p className="xb-item--location">
                        {item.location}
                      </p>

                      {/* ADDRESS */}
                      <p className="xb-item--address">
                        {item.address}
                      </p>

                      {/* PHONE */}
                      <a
                        href={`tel:${item.phone.replace(
                          /[\s-]/g,
                          ""
                        )}`}
                        className="xb-item--contact_info"
                      >
                        <strong>Phone:</strong>{" "}
                        {item.phone}
                      </a>

                      {/* EMAIL */}
                      <a
                        href={`mailto:${item.email}`}
                        className="xb-item--contact_info"
                      >
                        <strong>Email:</strong>{" "}
                        {item.email}
                      </a>

                      {/* =================================================
                          VIEW LOCATION BUTTON
                      ================================================= */}
                      <Link
                        to="/contact"
                        className="thm-btn form-btn digicomm-location-btn"
                      >
                        VIEW LOCATION

                        <span className="xb-icon">

                          <img
                            src={arrowWhite}
                            alt=""
                          />

                          <img
                            src={arrowBlack}
                            alt=""
                          />

                        </span>

                      </Link>

                    </div>

                  </div>

                </div>

              </div>
            ))}

          </div>
        </div>
      </section>

      {/* =====================================================
          CONTACT CARD CSS
      ===================================================== */}
      <style>{`

        /* =====================================================
           CARD COLUMN
        ===================================================== */

        .digicomm-contact-section .row > div {
          display: flex;
        }


        /* =====================================================
           CARD
        ===================================================== */

        .digicomm-contact-card {
          width: 100%;
          height: 100%;
        }


        .digicomm-contact-card .xb-item--inner {
          height: 100%;
          display: flex;
          flex-direction: column;
        }


        /* =====================================================
           IMAGE
        ===================================================== */

        .digicomm-contact-card .xb-img {
          width: 100%;

          /* Fixed landscape image height */
          height: 225px;

          overflow: hidden;
        }


        .digicomm-contact-card .xb-img > a {
          display: block;
          width: 100%;
          height: 100%;
        }


        .digicomm-contact-card .xb-img img {
          display: block;

          width: 100%;
          height: 100%;

          object-fit: cover;
          object-position: center;

          /*
          ===============================================
          Make sure no blur is applied to image
          ===============================================
          */
          filter: none !important;

          /*
          Disable unwanted image transformations
          */
          transform: none !important;
        }


        /* =====================================================
           DISABLE IMAGE HOVER EFFECT
        ===================================================== */

        .digicomm-contact-card:hover .xb-img img,
        .digicomm-contact-card .xb-img:hover img,
        .digicomm-contact-card .xb-img img:hover {

          filter: none !important;

          transform: none !important;

          opacity: 1 !important;
        }


        /*
        =====================================================
        OLD HOVER CLASS DISABLED
        =====================================================

        img-hove-effect was previously added here:

        className="
          xb-contact-items
          digicomm-contact-card
          img-hove-effect
          xb-border
        "

        It is intentionally NOT used now.

        =====================================================
        */


        /* =====================================================
           CARD CONTENT
        ===================================================== */

        .digicomm-contact-card .xb-item--holder {
          flex: 1;

          display: flex;
          flex-direction: column;
        }


        /* =====================================================
           LOCATION
        ===================================================== */

        .digicomm-contact-card .xb-item--location {
          margin-bottom: 12px;
        }


        /* =====================================================
           ADDRESS
        ===================================================== */

        .digicomm-contact-card .xb-item--address {
          margin: 0 0 20px;

          line-height: 1.7;

          min-height: 120px;
        }


        /* =====================================================
           PHONE / EMAIL
        ===================================================== */

        .digicomm-contact-card .xb-item--contact_info {
          display: block;

          margin-bottom: 8px;

          text-decoration: none;

          word-break: break-word;
        }


        .digicomm-contact-card
        .xb-item--contact_info:hover {
          text-decoration: none;
        }


        /* =====================================================
           BUTTON
        ===================================================== */

        .digicomm-location-btn {
          margin-top: auto !important;

          align-self: flex-start;
        }


        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 1199px) {

          .digicomm-contact-card .xb-img {
            height: 220px;
          }


          .digicomm-contact-card
          .xb-item--address {

            min-height: 100px;

          }

        }


        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 767px) {

          .digicomm-contact-section {
            padding-bottom: 80px;
          }


          .digicomm-contact-card .xb-img {
            height: 240px;
          }


          .digicomm-contact-card
          .xb-item--address {

            min-height: auto;

          }

        }

      `}</style>
    </>
  );
};

export default ContactInfoSection;

